export default "__VITE_ASSET__DxkpObXO__"